module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.14467/modules/marketing/modules/esp-sync/images/getresponse.png"